import axios from "axios";
import { API_HOST } from "@/core/variables";
import { IntegrationBaseData, LineIntegration, JandiIntegration } from "@/model";

class IntegrationRepository {
    read = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/publisher`)
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    updateWebchat = async (scenarioId: string, formData: FormData) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher`, formData, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    upsertKakaoTalk = async (scenarioId: string, data: any) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher/kakaotalk`, { referer: window.location.href, ...data })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    upsertNaverTalk = async (scenarioId: string, data: any) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher/navertalk`, { referer: window.location.href, ...data })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    checkFacebook = async (scenarioId: string, facebookPageId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/publisher/facebook`, {
                params: {
                    facebook_page_id: facebookPageId
                }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    upsertFacebook = async (scenarioId: string, data: any) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher/facebook`, { referer: window.location.href, ...data })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    checkInstagram = async (scenarioId: string, instagramBusinessAccountId: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/publisher/instagram`, {
                params: {
                    facebook_page_id: instagramBusinessAccountId
                }
            })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    upsertInstagram = async (scenarioId: string, data: any) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher/instagram`, { referer: window.location.href, ...data })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    upsertLine = async (scenarioId: string, data: LineIntegration) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher/line`, { referer: window.location.href, ...data })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    upsertJandi = async (scenarioId: string, data: JandiIntegration) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher/jandi`, { referer: window.location.href, ...data })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };

    upsertIntegration = async (scenarioId: string, integrationType: string, data: IntegrationBaseData) => {
        return axios
            .put(`${API_HOST}/scenario/${scenarioId}/publisher/${integrationType}`, { referer: window.location.href, ...data })
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error));
    };
}

const integrationRepository = new IntegrationRepository();

export default integrationRepository;
